<app-tabs>
  <app-tab title='Main Details'>
    <div class="form-row">
      <div class="form-group col-md-4">
        <label for="inputEmail4">Name</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.name' [class.is-invalid]='!this.subcontractor.name' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Contact Name</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.contactName' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Contact Telephone</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.contactTelephone' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Contact Email</label>
        <input type="email" name='name' [(ngModel)]='this.subcontractor.contactEmail' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Contact Address Line 1</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.contactAddressLine1' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Contact Address Line 2</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.contactAddressLine2' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Contact Address Line 3</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.contactAddressLine3' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Contact City</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.contactCity' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Contact Country</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.contactCountry' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Contact Postcode</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.contactPostCode' class="form-control" id="inputEmail4">
        <app-address-picker [postcode]='this.subcontractor.contactPostCode' (onAddressFound)='this.foundContactAddress($event)'></app-address-picker>
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Licence Number</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.licenceNumber' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Carrier Licence Number</label>
        <input type="text" name='name' [(ngModel)]='this.subcontractor.carrierLicenceNumber' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Carrier Licence Expiry date</label>
        <input type="date" name='name' [(ngModel)]='this.subcontractor.carrierLicenceExpiryDate' class="form-control" id="inputEmail4">
      </div>
    </div>

    <div class='form-row'>
      <div class="form-group col-md-12">
        <label for="inputPassword4">Notes</label>
        <textarea name='notes' [(ngModel)]='this.subcontractor.notes' class="form-control"></textarea>
      </div>
    </div>
  </app-tab>
  @if (this.subcontractor.id > 0) {
    <app-tab title='Depots'>
      <button class='btn btn-secondary' (click)='createNewDepot()'><i class="fas fa-plus"></i> New Depot</button>&nbsp;<br /><br />
      <app-grid
        entity='subcontractor'
        [filters]='this.filters'
        [columns]='this.columns'
        [buttons]='this.buttons'
        [searchFilters]='this.searchFilters'
        [searchFields]='this.searchFields'
      ></app-grid>
    </app-tab>
  }
</app-tabs>
